import React from "react";
import { Grid } from "@mui/material";
import LabeledTextArea from "../../Widgets/LabeledTextArea";
import LabeledSelect from "../../Widgets/LabeledSelect";
import LabeledDatePicker from "../../Widgets/LabeledDatePicker";
import { MedicalHistoryFormValues } from "./interface";

interface EditFieldsProps {
  formValues: MedicalHistoryFormValues;
  handleChange: (
    field: keyof MedicalHistoryFormValues
  ) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleDateChange: (field: keyof MedicalHistoryFormValues) => (value: Date | null) => void;
}

export const EditFields: React.FC<EditFieldsProps> = ({ formValues, handleChange, handleDateChange }) => {
  return (
    <Grid container spacing={7}>
      <LabeledSelect
        multiple
        label="Does the client have any allergies? If yes, what allergies?"
        value={formValues.allergies}
        onChange={(val: string[]) => {
          handleChange("allergies")({ target: { value: val as any } } as any);
        }}
        options={[
          { value: "MEDICATION_ALLERGIES", label: "Medication Allergies" },
          { value: "ENVIRONMENTAL_ALLERGIES", label: "Environmental Allergies" },
          { value: "FOOD_ALLERGIES", label: "Food Allergies" },
          { value: "NO_ALLERGIES_REPORTED", label: "No Allergies Reported" },
        ]}
      />
      <LabeledTextArea
        multiline
        label="Has the client ever had an emergency room visit? If yes, provide date(s)"
        value={formValues.emergencyRoomVisits}
        onChange={handleChange("emergencyRoomVisits")}
      />
      <LabeledTextArea
        multiline
        label="Has the client had a recent vision screen completed? If yes, list any interventions."
        value={formValues.visionScreen}
        onChange={handleChange("visionScreen")}
      />
      <LabeledTextArea
        multiline
        label="Is this client at risk of falling due to physical limitations or environmental risks?"
        value={formValues.fallRisk}
        onChange={handleChange("fallRisk")}
      />
      <LabeledDatePicker
        label="When was the client's last dental exam and cleaning?"
        value={formValues.lastDentalExam}
        onChange={handleDateChange("lastDentalExam")}
      />
      <LabeledDatePicker
        label="When was the client's last well-visit with a primary care physician?"
        value={formValues.lastWellVisit}
        onChange={handleDateChange("lastWellVisit")}
      />
    </Grid>
  );
};

export default EditFields;
